interface IEnhancedDocument extends Document {
  mozHidden?: boolean;
  msHidden?: boolean;
  webkitHidden?: boolean;
}

export const getVisibilityEventName = () => {
  const doc = document as IEnhancedDocument;
  let eventName = null;

  if (doc.webkitHidden !== undefined) {
    eventName = "webkitvisibilitychange";
  } else if (doc.mozHidden !== undefined) {
    eventName = "mozvisibilitychange";
  } else if (doc.msHidden !== undefined) {
    eventName = "msvisibilitychange";
  } else if (doc.hidden !== undefined) {
    eventName = "visibilitychange";
  }

  return eventName;
};

export const onVisibilityChange = (
  callback: ((visible: boolean) => void) | undefined,
): (() => void) => {
  const visibilityEventName = getVisibilityEventName();
  const event = () => {
    const doc = document as IEnhancedDocument;
    const hidden =
      doc.hidden || doc.mozHidden || doc.msHidden || doc.webkitHidden;

    if (callback) {
      callback(!hidden);
    }
  };

  if (visibilityEventName) {
    document.addEventListener(visibilityEventName, event, false);

    return () => {
      document.removeEventListener(visibilityEventName, event, false);
    };
  }

  return () => {};
};
